export const alertStyles = {
  width: "fit-content",
  blockSize: "fit-content",
  minWidth: "313px",
  maxWidth: "600px",
  borderRadius: "4px",
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
  boxShadow: "none",
};
